import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import styles from "../commanstyles.module.css";
import { FaMinusSquare, FaPlusSquare } from "react-icons/fa";
import { IoMdLock } from "react-icons/io";
import { FiDownload } from "react-icons/fi";
import { IoDocumentTextOutline } from "react-icons/io5";
import { formatIndianNumber } from "../../../Util/NumberConversion";

function Corporate_social_responsibility({ isSubScribe, data }) {
    const navigate = useNavigate();
    const [currentPage, setCurrentPage] = useState(1);
    const [isTableOpen, setIsTableOpen] = useState(true);
    const [selectedFinancialYear, setSelectedFinancialYear] = useState(
        data.length > 0 ? data[0].financialYear : ""
    );
    const [expandedOngoing, setExpandedOngoing] = useState({});
    const [expandedOthers, setExpandedOthers] = useState({});
    const rowsPerPage = 10;

    const toggleOngoingExpansion = (rowId) => {
        setExpandedOngoing((prev) => ({
            ...prev,
            [rowId]: !prev[rowId],
        }));
        // Close others expansion for this row
        setExpandedOthers((prev) => ({
            ...prev,
            [rowId]: false,
        }));
    };

    const toggleOthersExpansion = (rowId) => {
        setExpandedOthers((prev) => ({
            ...prev,
            [rowId]: !prev[rowId],
        }));
        // Close ongoing expansion for this row
        setExpandedOngoing((prev) => ({
            ...prev,
            [rowId]: false,
        }));
    };

    // Extract all available financial years from the data
    const financialYears = [...new Set(data.map((item) => item.financialYear))];

    // Filter data based on selected financial year
    const filteredData = selectedFinancialYear
        ? data.filter((item) => item.financialYear === selectedFinancialYear)
        : data;

    const totalPages = Math.ceil(filteredData.length / rowsPerPage);

    const handleClick = (page) => {
        setCurrentPage(page);
    };

    const handlePrevious = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }
    };

    const handleNext = () => {
        if (currentPage < totalPages) {
            setCurrentPage(currentPage + 1);
        }
    };

    const indexOfLastRow = currentPage * rowsPerPage;
    const indexOfFirstRow = indexOfLastRow - rowsPerPage;
    const currentData = filteredData.slice(indexOfFirstRow, indexOfLastRow);

    const toggleTable = () => {
        setIsTableOpen(!isTableOpen);
    };

    return (
        <div className={styles.table_subcontainer}>
            <div>
                {isSubScribe && (
                    <div className={styles.highlet_header_content1}>
                        <p className={styles.minuse_icon} onClick={toggleTable}>
                            {isTableOpen ? (
                                <FaMinusSquare size={22} />
                            ) : (
                                <FaPlusSquare size={22} />
                            )}
                        </p>
                        <h3 className={styles.highlet_text}>
                            Corporate Social Responsibility for FY Ending on
                            {filteredData.length > 0 &&
                                selectedFinancialYear &&
                                `- 31 Mar, ${selectedFinancialYear}`}
                        </h3>

                        {/* Financial Year Dropdown */}
                        {filteredData.length > 0 && (
                            <div className={styles.yearSelectContainer}>
                                <select
                                    // className={styles.financialYearDropdown}
                                    value={selectedFinancialYear}
                                    onChange={(e) =>
                                        setSelectedFinancialYear(e.target.value)
                                    }>
                                    <option value="" disabled>
                                        select Years
                                    </option>
                                    {financialYears.map((year) => (
                                        <option key={year} value={year}>
                                            {parseInt(year) - 1} - {year}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        )}
                    </div>
                )}

                {isTableOpen && (
                    <>
                        {!isSubScribe && (
                            <button className={styles.Subscription_msg} onClick={() => navigate("/kohere/mycredits", { state: { active: "BuyCredits" } })}>
                                <IoMdLock /> Subscription required to view data
                            </button>
                        )}

                        {isSubScribe && (
                            <>
                                {/* <div className={styles.referencedoc_main}>
    <div><b>Reference Documents</b></div>
    
    {filteredData.map((item) => (
      <div key={item.Id} className={styles.referencedoc_container}>
        {item.refDoc ? (
          <>
            <div>
              {item.refDoc?.MaiinFileName && (
                <a
                  href={item.refDoc?.fileurl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={styles.referencedoc_mainfilename}
                >
                  {item.refDoc?.MaiinFileName}
                </a>
              )}
              <ul style={{ padding: 0 }}>
                {item.refDoc?.Attachments && item.refDoc?.Attachments.length > 0 ? (
                  item.refDoc?.Attachments.map((attachment, index) => (
                    <li
                      key={index}
                      className={styles.referencedoc_Attachments}
                    >
                      <IoDocumentTextOutline
                        size={16}
                        style={{
                          marginRight: "8px",
                          color: "#2961EF",
                        }}
                      />
                      <a
                        href={attachment.fileurl}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{
                          textDecoration: "none",
                          color: "#2961EF",
                        }}
                      >
                        {attachment.Name}
                      </a>
                      <button
                        onClick={() => {
                          const link = document.createElement("a");
                          link.href = attachment.fileurl;
                          link.download = attachment.Name;
                          link.click();
                        }}
                        title="Download"
                        style={{
                          background: "none",
                          border: "none",
                          cursor: "pointer",
                          color: "#2961EF",
                          marginLeft: "5px",
                          textDecoration: "underline",
                        }}
                      >
                        <FiDownload />
                      </button>
                    </li>
                  ))
                ) : (
                  <span>No attachments available.</span>
                )}
              </ul>
            </div>
          </>
        ) : (
          <span>No documents available for selected year</span>
        )}
      </div>
    ))}
  </div> */}

                                {/* Data Table */}
                                <table className={styles.commantable}>
                                    <thead>
                                        <tr className={styles.tableHeaderRow}>
                                            <th className={styles.tableHeader}>
                                                Total CSR Obligation
                                            </th>
                                            <th className={styles.tableHeader}>
                                                CSR Amount Spent (Ongoing
                                                Projects)
                                            </th>
                                            <th className={styles.tableHeader}>
                                                CSR Amount Spent (Other than
                                                Ongoing Projects)
                                            </th>
                                            <th className={styles.tableHeader}>
                                                Total CSR Amount Spent
                                            </th>
                                            <th className={styles.tableHeader}>
                                                Excess/Deficit CSR Amount Spent
                                            </th>
                                            <th className={styles.tableHeader}>
                                                Amount Available for Set-Off
                                            </th>
                                            {/*  <th className={styles.tableHeader}>
                                                Name of the Project
                                            </th>
                                            <th className={styles.tableHeader}>
                                                Location of the Project
                                            </th>
                                            <th className={styles.tableHeader}>
                                                CSR Registration Number
                                            </th> */}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {currentData.length > 0 ? (
                                            currentData.map((row) => (
                                                <React.Fragment key={row.Id}>
                                                    <tr
                                                        className={
                                                            styles.tableRow
                                                        }>
                                                        <td
                                                            className={
                                                                styles.tableCell
                                                            }>
                                                            {row.csr_obligation_total ||
                                                                "-"}
                                                        </td>
                                                        <td
                                                            className={
                                                                styles.tableCell
                                                            }
                                                            onClick={() =>
                                                                toggleOngoingExpansion(
                                                                    row.Id
                                                                )
                                                            }
                                                            style={{
                                                                cursor: "pointer",
                                                            }}>
                                                            {expandedOngoing[
                                                                row.Id
                                                            ] ? (
                                                                <FaMinusSquare
                                                                    size={16}
                                                                />
                                                            ) : (
                                                                <FaPlusSquare
                                                                    size={16}
                                                                />
                                                            )}{" "}
                                                            {formatIndianNumber(row.csr_spent_ongoing_projects) ||
                                                                "-"}
                                                        </td>
                                                        <td
                                                            className={
                                                                styles.tableCell
                                                            }
                                                            onClick={() =>
                                                                toggleOthersExpansion(
                                                                    row.Id
                                                                )
                                                            }
                                                            style={{
                                                                cursor: "pointer",
                                                            }}>
                                                            {expandedOthers[
                                                                row.Id
                                                            ] ? (
                                                                <FaMinusSquare
                                                                    size={16}
                                                                />
                                                            ) : (
                                                                <FaPlusSquare
                                                                    size={16}
                                                                />
                                                            )}{" "}
                                                            {
                                                                formatIndianNumber(row.csr_amount_spent)
                                                            }
                                                        </td>
                                                        <td
                                                            className={
                                                                styles.tableCell
                                                            }>
                                                            {formatIndianNumber(row.csr_amount_spent) ||
                                                                "-"}
                                                        </td>
                                                        <td
                                                            className={
                                                                styles.tableCell
                                                            }>
                                                            {formatIndianNumber(row.excess_deficit_csr_spent)}
                                                        </td>
                                                        <td
                                                            className={
                                                                styles.tableCell
                                                            }>
                                                            {formatIndianNumber(row.amount_available_for_set_off)}
                                                        </td>
                                                        {/*   <td
                                                            className={
                                                                styles.tableCell
                                                            }>
                                                            {row.project_name ||
                                                                "-"}
                                                        </td>
                                                        <td
                                                            className={
                                                                styles.tableCell
                                                            }>
                                                            {row.project_location ||
                                                                "-"}
                                                        </td>
                                                        <td
                                                            className={
                                                                styles.tableCell
                                                            }>
                                                            {row.csr_registration_number ||
                                                                "-"}
                                                        </td> */}
                                                    </tr>
                                                    {expandedOngoing[
                                                        row.Id
                                                    ] && (
                                                            <tr
                                                                className={
                                                                    styles.detailsRow
                                                                }>
                                                                <td
                                                                    colSpan="9"
                                                                    style={{
                                                                        padding:
                                                                            "0",
                                                                    }}>
                                                                    <table
                                                                        className={
                                                                            styles.detailsTable
                                                                        }
                                                                        style={{
                                                                            width: "100%",
                                                                        }}>
                                                                        <thead>
                                                                            <tr
                                                                                style={{
                                                                                    backgroundColor:
                                                                                        "#f5f5f5",
                                                                                }}>
                                                                                <th
                                                                                    className={
                                                                                        styles.tableHeader
                                                                                    }>
                                                                                    Project
                                                                                    Name
                                                                                </th>
                                                                                <th
                                                                                    className={
                                                                                        styles.tableHeader
                                                                                    }>
                                                                                    Project
                                                                                    Location
                                                                                </th>
                                                                                <th
                                                                                    className={
                                                                                        styles.tableHeader
                                                                                    }>
                                                                                    CSR
                                                                                    Registration
                                                                                    Number
                                                                                </th>
                                                                                <th
                                                                                    className={
                                                                                        styles.tableHeader
                                                                                    }>
                                                                                    Amount
                                                                                    Spent
                                                                                </th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            {row.csrDetails &&
                                                                                row.csrDetails.filter(
                                                                                    (
                                                                                        d
                                                                                    ) =>
                                                                                        d.type ===
                                                                                        "ongoing"
                                                                                )
                                                                                    .length >
                                                                                0 ? (
                                                                                row.csrDetails
                                                                                    .filter(
                                                                                        (
                                                                                            d
                                                                                        ) =>
                                                                                            d.type ===
                                                                                            "ongoing"
                                                                                    )
                                                                                    .map(
                                                                                        (
                                                                                            detail,
                                                                                            index
                                                                                        ) => (
                                                                                            <tr
                                                                                                key={
                                                                                                    index
                                                                                                }
                                                                                                className={
                                                                                                    styles.tableRow
                                                                                                }>
                                                                                                <td
                                                                                                    className={
                                                                                                        styles.tableCell
                                                                                                    }>
                                                                                                    {detail.project_name ||
                                                                                                        "-"}
                                                                                                </td>
                                                                                                <td
                                                                                                    className={
                                                                                                        styles.tableCell
                                                                                                    }>
                                                                                                    {detail.project_location ||
                                                                                                        "-"}
                                                                                                </td>
                                                                                                <td
                                                                                                    className={
                                                                                                        styles.tableCell
                                                                                                    }>
                                                                                                    {detail.csr_registration_number ||
                                                                                                        "-"}
                                                                                                </td>
                                                                                                <td
                                                                                                    className={
                                                                                                        styles.tableCell
                                                                                                    }>
                                                                                                    {detail.amount_spent
                                                                                                        ? detail.amount_spent.toLocaleString(
                                                                                                            "en-IN"
                                                                                                        )
                                                                                                        : "-"}
                                                                                                </td>
                                                                                            </tr>
                                                                                        )
                                                                                    )
                                                                            ) : (
                                                                                <tr>
                                                                                    <td
                                                                                        colSpan="4"
                                                                                        className={
                                                                                            styles.noData
                                                                                        } style={{ textAlign: "center" }}>
                                                                                        No
                                                                                        CSR Details
                                                                                        Available
                                                                                    </td>
                                                                                </tr>
                                                                            )}
                                                                        </tbody>
                                                                    </table>
                                                                </td>
                                                            </tr>
                                                        )}
                                                    {expandedOthers[row.Id] && (
                                                        <tr
                                                            className={
                                                                styles.detailsRow
                                                            }>
                                                            <td
                                                                colSpan="9"
                                                                style={{
                                                                    padding:
                                                                        "0",
                                                                }}>
                                                                <table
                                                                    className={
                                                                        styles.detailsTable
                                                                    }
                                                                    style={{
                                                                        width: "100%",
                                                                    }}>
                                                                    <thead>
                                                                        <tr
                                                                            style={{
                                                                                backgroundColor:
                                                                                    "#f5f5f5",
                                                                            }}>
                                                                            <th
                                                                                className={
                                                                                    styles.tableHeader
                                                                                }>
                                                                                Project
                                                                                Name
                                                                            </th>
                                                                            <th
                                                                                className={
                                                                                    styles.tableHeader
                                                                                }>
                                                                                Project
                                                                                Location
                                                                            </th>
                                                                            <th
                                                                                className={
                                                                                    styles.tableHeader
                                                                                }>
                                                                                CSR
                                                                                Registration
                                                                                Number
                                                                            </th>
                                                                            <th
                                                                                className={
                                                                                    styles.tableHeader
                                                                                }>
                                                                                Amount
                                                                                Spent
                                                                            </th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        {row.csrDetails &&
                                                                            row.csrDetails.filter(
                                                                                (
                                                                                    d
                                                                                ) =>
                                                                                    d.type ===
                                                                                    "others"
                                                                            )
                                                                                .length >
                                                                            0 ? (
                                                                            row.csrDetails
                                                                                .filter(
                                                                                    (
                                                                                        d
                                                                                    ) =>
                                                                                        d.type ===
                                                                                        "others"
                                                                                )
                                                                                .map(
                                                                                    (
                                                                                        detail,
                                                                                        index
                                                                                    ) => (
                                                                                        <tr
                                                                                            key={
                                                                                                index
                                                                                            }
                                                                                            className={
                                                                                                styles.tableRow
                                                                                            }>
                                                                                            <td
                                                                                                className={
                                                                                                    styles.tableCell
                                                                                                }>
                                                                                                {detail.project_name ||
                                                                                                    "-"}
                                                                                            </td>
                                                                                            <td
                                                                                                className={
                                                                                                    styles.tableCell
                                                                                                }>
                                                                                                {detail.project_location ||
                                                                                                    "-"}
                                                                                            </td>
                                                                                            <td
                                                                                                className={
                                                                                                    styles.tableCell
                                                                                                }>
                                                                                                {detail.csr_registration_number ||
                                                                                                    "-"}
                                                                                            </td>
                                                                                            <td
                                                                                                className={
                                                                                                    styles.tableCell
                                                                                                }>
                                                                                                {detail.amount_spent
                                                                                                    ? detail.amount_spent.toLocaleString(
                                                                                                        "en-IN"
                                                                                                    )
                                                                                                    : "-"}
                                                                                            </td>
                                                                                        </tr>
                                                                                    )
                                                                                )
                                                                        ) : (
                                                                            <tr>
                                                                                <td
                                                                                    colSpan="4"
                                                                                    className={
                                                                                        styles.noData
                                                                                    }>
                                                                                    No
                                                                                    CSR Details
                                                                                    found
                                                                                </td>
                                                                            </tr>
                                                                        )}
                                                                    </tbody>
                                                                </table>
                                                            </td>
                                                        </tr>
                                                    )}
                                                </React.Fragment>
                                            ))
                                        ) : (
                                            <tr>
                                                <td
                                                    colSpan="9"
                                                    className={styles.noData} style={{ textAlign: "center" }}>
                                                    No CSR Details Available
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </>
                        )}

                        {isSubScribe && currentData.length > 0 && (
                            <div className={styles.pagination}>
                                <button
                                    onClick={handlePrevious}
                                    disabled={currentPage === 1}>
                                    &lt;
                                </button>
                                {[...Array(totalPages).keys()].map((num) => (
                                    <button
                                        key={num + 1}
                                        onClick={() => handleClick(num + 1)}
                                        className={
                                            currentPage === num + 1
                                                ? styles.active
                                                : ""
                                        }>
                                        {num + 1}
                                    </button>
                                ))}
                                <button
                                    onClick={handleNext}
                                    disabled={currentPage === totalPages}>
                                    &gt;
                                </button>
                            </div>
                        )}
                    </>
                )}
            </div>
        </div>
    );
}

export default Corporate_social_responsibility;
